import { render, staticRenderFns } from "./SurveyDetailView.vue?vue&type=template&id=b0e3e152&scoped=true"
import script from "./SurveyDetailView.vue?vue&type=script&lang=js"
export * from "./SurveyDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e3e152",
  null
  
)

export default component.exports